// MUI
import { Checkbox, FormControlLabel, FormGroup, Stack } from "@mui/material";

// Components
import CustomizedSwitches from "@Layouts/components/InputComponents/CustomizedSwitches";

// Types
import { IFilterConfiguration } from "@Settings/types/Common/model";

type CheckboxWithProps = {
	isLoading: boolean;
	category: string;
	activeTabName: string;
	filterConfiguration: IFilterConfiguration;
	// Callbacks
	onUpdateInitialDataFilter: (tab: string, category: string, config: IFilterConfiguration) => void;
};

export function CheckboxWithSwitch(props: Readonly<CheckboxWithProps>) {
	const { isLoading, activeTabName, category, filterConfiguration, onUpdateInitialDataFilter } = props;

	return (
		<FormGroup>
			<Stack>
				<FormControlLabel
					control={
						<Checkbox
							checked={filterConfiguration.included}
							disabled={filterConfiguration.disabled || isLoading}
							// Callbacks
							onChange={(e) =>
								onUpdateInitialDataFilter(activeTabName, category, { ...filterConfiguration, included: e.target.checked })
							}
						/>
					}
					label={category}
				/>
				<FormControlLabel
					control={
						<CustomizedSwitches
							checked={filterConfiguration.enabled}
							disabled={filterConfiguration.disabled || isLoading}
							sx={{ ml: -2 }}
							// Callbacks
							onChange={(val: boolean) =>
								onUpdateInitialDataFilter(activeTabName, category, { ...filterConfiguration, enabled: val })
							}
						/>
					}
					label={""}
				/>
			</Stack>
		</FormGroup>
	);
}
